import React from 'react'

import { PrimaryButton } from '../../common/Buttons'
import ButtonStripe from '../../common/ButtonStripe'
import { i18n } from '../../i18n'

interface IProps {
  enabled: boolean
  onClick(): void
}

export const AddressSubmit: React.FC<IProps> = ({ enabled, onClick }) => (
  <ButtonStripe>
    <PrimaryButton
      color="primary"
      disabled={!enabled}
      onClick={onClick}
      data-testid="AddressSubmit"
    >
      {i18n.t`Confirm address`}
    </PrimaryButton>
  </ButtonStripe>
)

export default AddressSubmit
